import { Slice, createSlice } from "@reduxjs/toolkit";
import { fetchHeatMap } from "../thunk/MapSliceThunk";

const initialData: any = [];

const HeatMapSlice: Slice<any, {}, "HeatMapSlice"> = createSlice({
    name: "HeatMapSlice",
    initialState: { data: initialData, isLoading: false, error: "" },
    reducers: {},
    extraReducers(builder) {
        builder.addCase(fetchHeatMap.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(fetchHeatMap.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        });
        builder.addCase(fetchHeatMap.rejected, (state, action) => {
            state.isLoading = false
            state.error = action.error.message ?? ""
        });
    }
})

export default HeatMapSlice